export default "__VITE_ASSET__tGR_T3Kr__"